// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "quickbooks.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "quickbooks.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { Bool } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
// @generated message type with reflection information, may provide speed optimized methods
class OAuthToken$Type extends MessageType {
    constructor() {
        super("OAuthToken", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expires_in", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 4, name: "token_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "scope", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.accessToken = "";
        message.refreshToken = "";
        message.expiresIn = 0n;
        message.tokenType = "";
        message.scope = "";
        message.realmId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* string refresh_token */ 2:
                    message.refreshToken = reader.string();
                    break;
                case /* int64 expires_in */ 3:
                    message.expiresIn = reader.int64().toBigInt();
                    break;
                case /* string token_type */ 4:
                    message.tokenType = reader.string();
                    break;
                case /* string scope */ 5:
                    message.scope = reader.string();
                    break;
                case /* string realm_id */ 6:
                    message.realmId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* string refresh_token = 2; */
        if (message.refreshToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.refreshToken);
        /* int64 expires_in = 3; */
        if (message.expiresIn !== 0n)
            writer.tag(3, WireType.Varint).int64(message.expiresIn);
        /* string token_type = 4; */
        if (message.tokenType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tokenType);
        /* string scope = 5; */
        if (message.scope !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.scope);
        /* string realm_id = 6; */
        if (message.realmId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.realmId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message OAuthToken
 */
export const OAuthToken = new OAuthToken$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBGetAuthURLRequest$Type extends MessageType {
    constructor() {
        super("QBGetAuthURLRequest", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.state = "";
        message.redirectUri = "";
        message.scopes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string state */ 1:
                    message.state = reader.string();
                    break;
                case /* string redirect_uri */ 2:
                    message.redirectUri = reader.string();
                    break;
                case /* repeated string scopes */ 3:
                    message.scopes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string state = 1; */
        if (message.state !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.state);
        /* string redirect_uri = 2; */
        if (message.redirectUri !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.redirectUri);
        /* repeated string scopes = 3; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.scopes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBGetAuthURLRequest
 */
export const QBGetAuthURLRequest = new QBGetAuthURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBGetAuthURLResponse$Type extends MessageType {
    constructor() {
        super("QBGetAuthURLResponse", [
            { no: 1, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.url = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string url */ 1:
                    message.url = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string url = 1; */
        if (message.url !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.url);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBGetAuthURLResponse
 */
export const QBGetAuthURLResponse = new QBGetAuthURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBExchangeCodeRequest$Type extends MessageType {
    constructor() {
        super("QBExchangeCodeRequest", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.code = "";
        message.redirectUri = "";
        message.userId = 0;
        message.realmId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string redirect_uri */ 2:
                    message.redirectUri = reader.string();
                    break;
                case /* int32 user_id */ 3:
                    message.userId = reader.int32();
                    break;
                case /* string realm_id */ 4:
                    message.realmId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string redirect_uri = 2; */
        if (message.redirectUri !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.redirectUri);
        /* int32 user_id = 3; */
        if (message.userId !== 0)
            writer.tag(3, WireType.Varint).int32(message.userId);
        /* string realm_id = 4; */
        if (message.realmId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.realmId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBExchangeCodeRequest
 */
export const QBExchangeCodeRequest = new QBExchangeCodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBRefreshTokenRequest$Type extends MessageType {
    constructor() {
        super("QBRefreshTokenRequest", [
            { no: 1, name: "refresh_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.refreshToken = "";
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string refresh_token */ 1:
                    message.refreshToken = reader.string();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string refresh_token = 1; */
        if (message.refreshToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refreshToken);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBRefreshTokenRequest
 */
export const QBRefreshTokenRequest = new QBRefreshTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CompanyInfo$Type extends MessageType {
    constructor() {
        super("CompanyInfo", [
            { no: 1, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "company_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "last_updated_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.companyName = "";
        message.companyId = "";
        message.country = "";
        message.createdTime = "";
        message.lastUpdatedTime = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string company_name */ 1:
                    message.companyName = reader.string();
                    break;
                case /* string company_id */ 2:
                    message.companyId = reader.string();
                    break;
                case /* string country */ 3:
                    message.country = reader.string();
                    break;
                case /* string created_time */ 4:
                    message.createdTime = reader.string();
                    break;
                case /* string last_updated_time */ 5:
                    message.lastUpdatedTime = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string company_name = 1; */
        if (message.companyName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.companyName);
        /* string company_id = 2; */
        if (message.companyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.companyId);
        /* string country = 3; */
        if (message.country !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.country);
        /* string created_time = 4; */
        if (message.createdTime !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.createdTime);
        /* string last_updated_time = 5; */
        if (message.lastUpdatedTime !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lastUpdatedTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CompanyInfo
 */
export const CompanyInfo = new CompanyInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCustomer$Type extends MessageType {
    constructor() {
        super("QBCustomer", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "company_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "billing_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "shipping_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "created_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "last_updated_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "is_sub_customer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "parent_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "fully_qualified_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.companyName = "";
        message.email = "";
        message.phone = "";
        message.billingAddress = "";
        message.shippingAddress = "";
        message.active = false;
        message.createdTime = "";
        message.lastUpdatedTime = "";
        message.isSubCustomer = false;
        message.parentCustomerId = "";
        message.fullyQualifiedName = "";
        message.balance = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string company_name */ 3:
                    message.companyName = reader.string();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* string phone */ 5:
                    message.phone = reader.string();
                    break;
                case /* string billing_address */ 6:
                    message.billingAddress = reader.string();
                    break;
                case /* string shipping_address */ 7:
                    message.shippingAddress = reader.string();
                    break;
                case /* bool active */ 8:
                    message.active = reader.bool();
                    break;
                case /* string created_time */ 9:
                    message.createdTime = reader.string();
                    break;
                case /* string last_updated_time */ 10:
                    message.lastUpdatedTime = reader.string();
                    break;
                case /* bool is_sub_customer */ 11:
                    message.isSubCustomer = reader.bool();
                    break;
                case /* string parent_customer_id */ 12:
                    message.parentCustomerId = reader.string();
                    break;
                case /* string fully_qualified_name */ 13:
                    message.fullyQualifiedName = reader.string();
                    break;
                case /* double balance */ 14:
                    message.balance = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string company_name = 3; */
        if (message.companyName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.companyName);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* string phone = 5; */
        if (message.phone !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.phone);
        /* string billing_address = 6; */
        if (message.billingAddress !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.billingAddress);
        /* string shipping_address = 7; */
        if (message.shippingAddress !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.shippingAddress);
        /* bool active = 8; */
        if (message.active !== false)
            writer.tag(8, WireType.Varint).bool(message.active);
        /* string created_time = 9; */
        if (message.createdTime !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.createdTime);
        /* string last_updated_time = 10; */
        if (message.lastUpdatedTime !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.lastUpdatedTime);
        /* bool is_sub_customer = 11; */
        if (message.isSubCustomer !== false)
            writer.tag(11, WireType.Varint).bool(message.isSubCustomer);
        /* string parent_customer_id = 12; */
        if (message.parentCustomerId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.parentCustomerId);
        /* string fully_qualified_name = 13; */
        if (message.fullyQualifiedName !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.fullyQualifiedName);
        /* double balance = 14; */
        if (message.balance !== 0)
            writer.tag(14, WireType.Bit64).double(message.balance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCustomer
 */
export const QBCustomer = new QBCustomer$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBItem$Type extends MessageType {
    constructor() {
        super("QBItem", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "unit_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "qty_on_hand", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "income_account_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.description = "";
        message.type = "";
        message.unitPrice = 0;
        message.qtyOnHand = 0;
        message.incomeAccountRef = "";
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string type */ 4:
                    message.type = reader.string();
                    break;
                case /* double unit_price */ 5:
                    message.unitPrice = reader.double();
                    break;
                case /* int32 qty_on_hand */ 6:
                    message.qtyOnHand = reader.int32();
                    break;
                case /* string income_account_ref */ 7:
                    message.incomeAccountRef = reader.string();
                    break;
                case /* bool active */ 8:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string type = 4; */
        if (message.type !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.type);
        /* double unit_price = 5; */
        if (message.unitPrice !== 0)
            writer.tag(5, WireType.Bit64).double(message.unitPrice);
        /* int32 qty_on_hand = 6; */
        if (message.qtyOnHand !== 0)
            writer.tag(6, WireType.Varint).int32(message.qtyOnHand);
        /* string income_account_ref = 7; */
        if (message.incomeAccountRef !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.incomeAccountRef);
        /* bool active = 8; */
        if (message.active !== false)
            writer.tag(8, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBItem
 */
export const QBItem = new QBItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBInvoice$Type extends MessageType {
    constructor() {
        super("QBInvoice", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "doc_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_amt", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "txn_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "email_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "print_status", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBInvoiceLine },
            { no: 11, name: "sync_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.docNumber = "";
        message.customerRef = "";
        message.totalAmt = 0;
        message.balance = 0;
        message.txnDate = "";
        message.dueDate = "";
        message.emailStatus = "";
        message.printStatus = false;
        message.lineItems = [];
        message.syncToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string doc_number */ 2:
                    message.docNumber = reader.string();
                    break;
                case /* string customer_ref */ 3:
                    message.customerRef = reader.string();
                    break;
                case /* double total_amt */ 4:
                    message.totalAmt = reader.double();
                    break;
                case /* double balance */ 5:
                    message.balance = reader.double();
                    break;
                case /* string txn_date */ 6:
                    message.txnDate = reader.string();
                    break;
                case /* string due_date */ 7:
                    message.dueDate = reader.string();
                    break;
                case /* string email_status */ 8:
                    message.emailStatus = reader.string();
                    break;
                case /* bool print_status */ 9:
                    message.printStatus = reader.bool();
                    break;
                case /* repeated QBInvoiceLine line_items */ 10:
                    message.lineItems.push(QBInvoiceLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string sync_token */ 11:
                    message.syncToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string doc_number = 2; */
        if (message.docNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.docNumber);
        /* string customer_ref = 3; */
        if (message.customerRef !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customerRef);
        /* double total_amt = 4; */
        if (message.totalAmt !== 0)
            writer.tag(4, WireType.Bit64).double(message.totalAmt);
        /* double balance = 5; */
        if (message.balance !== 0)
            writer.tag(5, WireType.Bit64).double(message.balance);
        /* string txn_date = 6; */
        if (message.txnDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.txnDate);
        /* string due_date = 7; */
        if (message.dueDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dueDate);
        /* string email_status = 8; */
        if (message.emailStatus !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.emailStatus);
        /* bool print_status = 9; */
        if (message.printStatus !== false)
            writer.tag(9, WireType.Varint).bool(message.printStatus);
        /* repeated QBInvoiceLine line_items = 10; */
        for (let i = 0; i < message.lineItems.length; i++)
            QBInvoiceLine.internalBinaryWrite(message.lineItems[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string sync_token = 11; */
        if (message.syncToken !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.syncToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBInvoice
 */
export const QBInvoice = new QBInvoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBInvoiceLine$Type extends MessageType {
    constructor() {
        super("QBInvoiceLine", [
            { no: 1, name: "line_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_ref", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "qty", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "unit_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lineNum = 0;
        message.itemRef = "";
        message.qty = 0;
        message.unitPrice = 0;
        message.amount = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 line_num */ 1:
                    message.lineNum = reader.int32();
                    break;
                case /* string item_ref */ 2:
                    message.itemRef = reader.string();
                    break;
                case /* double qty */ 3:
                    message.qty = reader.double();
                    break;
                case /* double unit_price */ 4:
                    message.unitPrice = reader.double();
                    break;
                case /* double amount */ 5:
                    message.amount = reader.double();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 line_num = 1; */
        if (message.lineNum !== 0)
            writer.tag(1, WireType.Varint).int32(message.lineNum);
        /* string item_ref = 2; */
        if (message.itemRef !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.itemRef);
        /* double qty = 3; */
        if (message.qty !== 0)
            writer.tag(3, WireType.Bit64).double(message.qty);
        /* double unit_price = 4; */
        if (message.unitPrice !== 0)
            writer.tag(4, WireType.Bit64).double(message.unitPrice);
        /* double amount = 5; */
        if (message.amount !== 0)
            writer.tag(5, WireType.Bit64).double(message.amount);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBInvoiceLine
 */
export const QBInvoiceLine = new QBInvoiceLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBSyncInvoiceLineItem$Type extends MessageType {
    constructor() {
        super("QBSyncInvoiceLineItem", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "quantity", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "unit_price", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "quote_used_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.description = "";
        message.quantity = 0;
        message.unitPrice = 0;
        message.amount = 0;
        message.itemType = "";
        message.quoteUsedId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.description = reader.string();
                    break;
                case /* double quantity */ 2:
                    message.quantity = reader.double();
                    break;
                case /* double unit_price */ 3:
                    message.unitPrice = reader.double();
                    break;
                case /* double amount */ 4:
                    message.amount = reader.double();
                    break;
                case /* string item_type */ 5:
                    message.itemType = reader.string();
                    break;
                case /* int32 quote_used_id */ 6:
                    message.quoteUsedId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string description = 1; */
        if (message.description !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.description);
        /* double quantity = 2; */
        if (message.quantity !== 0)
            writer.tag(2, WireType.Bit64).double(message.quantity);
        /* double unit_price = 3; */
        if (message.unitPrice !== 0)
            writer.tag(3, WireType.Bit64).double(message.unitPrice);
        /* double amount = 4; */
        if (message.amount !== 0)
            writer.tag(4, WireType.Bit64).double(message.amount);
        /* string item_type = 5; */
        if (message.itemType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.itemType);
        /* int32 quote_used_id = 6; */
        if (message.quoteUsedId !== 0)
            writer.tag(6, WireType.Varint).int32(message.quoteUsedId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBSyncInvoiceLineItem
 */
export const QBSyncInvoiceLineItem = new QBSyncInvoiceLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBSyncInvoiceRequest$Type extends MessageType {
    constructor() {
        super("QBSyncInvoiceRequest", [
            { no: 1, name: "kalos_invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "doc_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "existing_qb_invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "project_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "retainage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBSyncInvoiceLineItem },
            { no: 12, name: "business_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kalosInvoiceId = 0;
        message.projectId = 0;
        message.customerUserId = 0;
        message.docNumber = "";
        message.amount = 0;
        message.invoiceDate = "";
        message.description = "";
        message.existingQbInvoiceId = "";
        message.projectName = "";
        message.retainage = 0;
        message.lineItems = [];
        message.businessId = 0;
        message.departmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 kalos_invoice_id */ 1:
                    message.kalosInvoiceId = reader.int32();
                    break;
                case /* int32 project_id */ 2:
                    message.projectId = reader.int32();
                    break;
                case /* int32 customer_user_id */ 3:
                    message.customerUserId = reader.int32();
                    break;
                case /* string doc_number */ 4:
                    message.docNumber = reader.string();
                    break;
                case /* double amount */ 5:
                    message.amount = reader.double();
                    break;
                case /* string invoice_date */ 6:
                    message.invoiceDate = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* string existing_qb_invoice_id */ 8:
                    message.existingQbInvoiceId = reader.string();
                    break;
                case /* string project_name */ 9:
                    message.projectName = reader.string();
                    break;
                case /* double retainage */ 10:
                    message.retainage = reader.double();
                    break;
                case /* repeated QBSyncInvoiceLineItem line_items */ 11:
                    message.lineItems.push(QBSyncInvoiceLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 business_id */ 12:
                    message.businessId = reader.int32();
                    break;
                case /* int32 department_id */ 13:
                    message.departmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 kalos_invoice_id = 1; */
        if (message.kalosInvoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kalosInvoiceId);
        /* int32 project_id = 2; */
        if (message.projectId !== 0)
            writer.tag(2, WireType.Varint).int32(message.projectId);
        /* int32 customer_user_id = 3; */
        if (message.customerUserId !== 0)
            writer.tag(3, WireType.Varint).int32(message.customerUserId);
        /* string doc_number = 4; */
        if (message.docNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.docNumber);
        /* double amount = 5; */
        if (message.amount !== 0)
            writer.tag(5, WireType.Bit64).double(message.amount);
        /* string invoice_date = 6; */
        if (message.invoiceDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.invoiceDate);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* string existing_qb_invoice_id = 8; */
        if (message.existingQbInvoiceId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.existingQbInvoiceId);
        /* string project_name = 9; */
        if (message.projectName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.projectName);
        /* double retainage = 10; */
        if (message.retainage !== 0)
            writer.tag(10, WireType.Bit64).double(message.retainage);
        /* repeated QBSyncInvoiceLineItem line_items = 11; */
        for (let i = 0; i < message.lineItems.length; i++)
            QBSyncInvoiceLineItem.internalBinaryWrite(message.lineItems[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* int32 business_id = 12; */
        if (message.businessId !== 0)
            writer.tag(12, WireType.Varint).int32(message.businessId);
        /* int32 department_id = 13; */
        if (message.departmentId !== 0)
            writer.tag(13, WireType.Varint).int32(message.departmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBSyncInvoiceRequest
 */
export const QBSyncInvoiceRequest = new QBSyncInvoiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBSyncInvoiceResponse$Type extends MessageType {
    constructor() {
        super("QBSyncInvoiceResponse", [
            { no: 1, name: "qb_invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.qbInvoiceId = "";
        message.created = false;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string qb_invoice_id */ 1:
                    message.qbInvoiceId = reader.string();
                    break;
                case /* bool created */ 2:
                    message.created = reader.bool();
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string qb_invoice_id = 1; */
        if (message.qbInvoiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.qbInvoiceId);
        /* bool created = 2; */
        if (message.created !== false)
            writer.tag(2, WireType.Varint).bool(message.created);
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBSyncInvoiceResponse
 */
export const QBSyncInvoiceResponse = new QBSyncInvoiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBVoidInvoiceRequest$Type extends MessageType {
    constructor() {
        super("QBVoidInvoiceRequest", [
            { no: 1, name: "qb_invoice_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.qbInvoiceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string qb_invoice_id */ 1:
                    message.qbInvoiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string qb_invoice_id = 1; */
        if (message.qbInvoiceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.qbInvoiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBVoidInvoiceRequest
 */
export const QBVoidInvoiceRequest = new QBVoidInvoiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBVoidInvoiceResponse$Type extends MessageType {
    constructor() {
        super("QBVoidInvoiceResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.success = false;
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBVoidInvoiceResponse
 */
export const QBVoidInvoiceResponse = new QBVoidInvoiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBSyncCustomerRequest$Type extends MessageType {
    constructor() {
        super("QBSyncCustomerRequest", [
            { no: 1, name: "kalos_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kalosUserId = 0;
        message.displayName = "";
        message.email = "";
        message.phone = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 kalos_user_id */ 1:
                    message.kalosUserId = reader.int32();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string email */ 3:
                    message.email = reader.string();
                    break;
                case /* string phone */ 4:
                    message.phone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 kalos_user_id = 1; */
        if (message.kalosUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kalosUserId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string email = 3; */
        if (message.email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.email);
        /* string phone = 4; */
        if (message.phone !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.phone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBSyncCustomerRequest
 */
export const QBSyncCustomerRequest = new QBSyncCustomerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBSyncCustomerResponse$Type extends MessageType {
    constructor() {
        super("QBSyncCustomerResponse", [
            { no: 1, name: "qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.qbCustomerId = "";
        message.created = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string qb_customer_id */ 1:
                    message.qbCustomerId = reader.string();
                    break;
                case /* bool created */ 2:
                    message.created = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string qb_customer_id = 1; */
        if (message.qbCustomerId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.qbCustomerId);
        /* bool created = 2; */
        if (message.created !== false)
            writer.tag(2, WireType.Varint).bool(message.created);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBSyncCustomerResponse
 */
export const QBSyncCustomerResponse = new QBSyncCustomerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBHealthStatus$Type extends MessageType {
    constructor() {
        super("QBHealthStatus", [
            { no: 1, name: "is_configured", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "token_valid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "admin_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "token_expires_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "last_sync_error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.isConfigured = false;
        message.tokenValid = false;
        message.realmId = "";
        message.adminUserId = 0;
        message.tokenExpiresAt = "";
        message.lastSyncError = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_configured */ 1:
                    message.isConfigured = reader.bool();
                    break;
                case /* bool token_valid */ 2:
                    message.tokenValid = reader.bool();
                    break;
                case /* string realm_id */ 3:
                    message.realmId = reader.string();
                    break;
                case /* int32 admin_user_id */ 4:
                    message.adminUserId = reader.int32();
                    break;
                case /* string token_expires_at */ 5:
                    message.tokenExpiresAt = reader.string();
                    break;
                case /* string last_sync_error */ 6:
                    message.lastSyncError = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool is_configured = 1; */
        if (message.isConfigured !== false)
            writer.tag(1, WireType.Varint).bool(message.isConfigured);
        /* bool token_valid = 2; */
        if (message.tokenValid !== false)
            writer.tag(2, WireType.Varint).bool(message.tokenValid);
        /* string realm_id = 3; */
        if (message.realmId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.realmId);
        /* int32 admin_user_id = 4; */
        if (message.adminUserId !== 0)
            writer.tag(4, WireType.Varint).int32(message.adminUserId);
        /* string token_expires_at = 5; */
        if (message.tokenExpiresAt !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.tokenExpiresAt);
        /* string last_sync_error = 6; */
        if (message.lastSyncError !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lastSyncError);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBHealthStatus
 */
export const QBHealthStatus = new QBHealthStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDiscoverItemsRequest$Type extends MessageType {
    constructor() {
        super("QBDiscoverItemsRequest", [
            { no: 1, name: "type_filter", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.typeFilter = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string type_filter */ 1:
                    message.typeFilter = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string type_filter = 1; */
        if (message.typeFilter !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.typeFilter);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDiscoverItemsRequest
 */
export const QBDiscoverItemsRequest = new QBDiscoverItemsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDiscoverItemsResponse$Type extends MessageType {
    constructor() {
        super("QBDiscoverItemsResponse", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBItem items */ 1:
                    message.items.push(QBItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            QBItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDiscoverItemsResponse
 */
export const QBDiscoverItemsResponse = new QBDiscoverItemsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBItemMapping$Type extends MessageType {
    constructor() {
        super("QBItemMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "qb_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "qb_item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.realmId = "";
        message.itemType = "";
        message.qbItemId = "";
        message.qbItemName = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string realm_id */ 2:
                    message.realmId = reader.string();
                    break;
                case /* string item_type */ 3:
                    message.itemType = reader.string();
                    break;
                case /* string qb_item_id */ 4:
                    message.qbItemId = reader.string();
                    break;
                case /* string qb_item_name */ 5:
                    message.qbItemName = reader.string();
                    break;
                case /* bool is_active */ 6:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string realm_id = 2; */
        if (message.realmId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.realmId);
        /* string item_type = 3; */
        if (message.itemType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.itemType);
        /* string qb_item_id = 4; */
        if (message.qbItemId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.qbItemId);
        /* string qb_item_name = 5; */
        if (message.qbItemName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.qbItemName);
        /* bool is_active = 6; */
        if (message.isActive !== false)
            writer.tag(6, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBItemMapping
 */
export const QBItemMapping = new QBItemMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBItemMappingList$Type extends MessageType {
    constructor() {
        super("QBItemMappingList", [
            { no: 1, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBItemMapping }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.mappings = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBItemMapping mappings */ 1:
                    message.mappings.push(QBItemMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBItemMapping mappings = 1; */
        for (let i = 0; i < message.mappings.length; i++)
            QBItemMapping.internalBinaryWrite(message.mappings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBItemMappingList
 */
export const QBItemMappingList = new QBItemMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCreateItemMappingRequest$Type extends MessageType {
    constructor() {
        super("QBCreateItemMappingRequest", [
            { no: 1, name: "item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "qb_item_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "qb_item_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.itemType = "";
        message.qbItemId = "";
        message.qbItemName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string item_type */ 1:
                    message.itemType = reader.string();
                    break;
                case /* string qb_item_id */ 2:
                    message.qbItemId = reader.string();
                    break;
                case /* string qb_item_name */ 3:
                    message.qbItemName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string item_type = 1; */
        if (message.itemType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.itemType);
        /* string qb_item_id = 2; */
        if (message.qbItemId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.qbItemId);
        /* string qb_item_name = 3; */
        if (message.qbItemName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.qbItemName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCreateItemMappingRequest
 */
export const QBCreateItemMappingRequest = new QBCreateItemMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDeleteItemMappingRequest$Type extends MessageType {
    constructor() {
        super("QBDeleteItemMappingRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "item_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.itemType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string item_type */ 2:
                    message.itemType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string item_type = 2; */
        if (message.itemType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.itemType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDeleteItemMappingRequest
 */
export const QBDeleteItemMappingRequest = new QBDeleteItemMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCustomerMapping$Type extends MessageType {
    constructor() {
        super("QBCustomerMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "kalos_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "qb_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "is_sub_customer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "parent_qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "kalos_user_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.kalosUserId = 0;
        message.qbCustomerId = "";
        message.qbDisplayName = "";
        message.realmId = "";
        message.projectId = 0;
        message.isSubCustomer = false;
        message.parentQbCustomerId = "";
        message.createdAt = "";
        message.updatedAt = "";
        message.kalosUserName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 kalos_user_id */ 2:
                    message.kalosUserId = reader.int32();
                    break;
                case /* string qb_customer_id */ 3:
                    message.qbCustomerId = reader.string();
                    break;
                case /* string qb_display_name */ 4:
                    message.qbDisplayName = reader.string();
                    break;
                case /* string realm_id */ 5:
                    message.realmId = reader.string();
                    break;
                case /* int32 project_id */ 6:
                    message.projectId = reader.int32();
                    break;
                case /* bool is_sub_customer */ 7:
                    message.isSubCustomer = reader.bool();
                    break;
                case /* string parent_qb_customer_id */ 8:
                    message.parentQbCustomerId = reader.string();
                    break;
                case /* string created_at */ 9:
                    message.createdAt = reader.string();
                    break;
                case /* string updated_at */ 10:
                    message.updatedAt = reader.string();
                    break;
                case /* string kalos_user_name */ 11:
                    message.kalosUserName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 kalos_user_id = 2; */
        if (message.kalosUserId !== 0)
            writer.tag(2, WireType.Varint).int32(message.kalosUserId);
        /* string qb_customer_id = 3; */
        if (message.qbCustomerId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.qbCustomerId);
        /* string qb_display_name = 4; */
        if (message.qbDisplayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.qbDisplayName);
        /* string realm_id = 5; */
        if (message.realmId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.realmId);
        /* int32 project_id = 6; */
        if (message.projectId !== 0)
            writer.tag(6, WireType.Varint).int32(message.projectId);
        /* bool is_sub_customer = 7; */
        if (message.isSubCustomer !== false)
            writer.tag(7, WireType.Varint).bool(message.isSubCustomer);
        /* string parent_qb_customer_id = 8; */
        if (message.parentQbCustomerId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.parentQbCustomerId);
        /* string created_at = 9; */
        if (message.createdAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.createdAt);
        /* string updated_at = 10; */
        if (message.updatedAt !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.updatedAt);
        /* string kalos_user_name = 11; */
        if (message.kalosUserName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.kalosUserName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCustomerMapping
 */
export const QBCustomerMapping = new QBCustomerMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCustomerMappingList$Type extends MessageType {
    constructor() {
        super("QBCustomerMappingList", [
            { no: 1, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBCustomerMapping }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.mappings = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBCustomerMapping mappings */ 1:
                    message.mappings.push(QBCustomerMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBCustomerMapping mappings = 1; */
        for (let i = 0; i < message.mappings.length; i++)
            QBCustomerMapping.internalBinaryWrite(message.mappings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCustomerMappingList
 */
export const QBCustomerMappingList = new QBCustomerMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCreateCustomerMappingRequest$Type extends MessageType {
    constructor() {
        super("QBCreateCustomerMappingRequest", [
            { no: 1, name: "kalos_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "qb_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "project_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "parent_qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kalosUserId = 0;
        message.qbCustomerId = "";
        message.qbDisplayName = "";
        message.projectId = 0;
        message.parentQbCustomerId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 kalos_user_id */ 1:
                    message.kalosUserId = reader.int32();
                    break;
                case /* string qb_customer_id */ 2:
                    message.qbCustomerId = reader.string();
                    break;
                case /* string qb_display_name */ 3:
                    message.qbDisplayName = reader.string();
                    break;
                case /* int32 project_id */ 4:
                    message.projectId = reader.int32();
                    break;
                case /* string parent_qb_customer_id */ 5:
                    message.parentQbCustomerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 kalos_user_id = 1; */
        if (message.kalosUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kalosUserId);
        /* string qb_customer_id = 2; */
        if (message.qbCustomerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.qbCustomerId);
        /* string qb_display_name = 3; */
        if (message.qbDisplayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.qbDisplayName);
        /* int32 project_id = 4; */
        if (message.projectId !== 0)
            writer.tag(4, WireType.Varint).int32(message.projectId);
        /* string parent_qb_customer_id = 5; */
        if (message.parentQbCustomerId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.parentQbCustomerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCreateCustomerMappingRequest
 */
export const QBCreateCustomerMappingRequest = new QBCreateCustomerMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDeleteCustomerMappingRequest$Type extends MessageType {
    constructor() {
        super("QBDeleteCustomerMappingRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDeleteCustomerMappingRequest
 */
export const QBDeleteCustomerMappingRequest = new QBDeleteCustomerMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBListQBOCustomersRequest$Type extends MessageType {
    constructor() {
        super("QBListQBOCustomersRequest", [
            { no: 1, name: "start_position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "max_results", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "include_inactive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startPosition = 0;
        message.maxResults = 0;
        message.includeInactive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 start_position */ 1:
                    message.startPosition = reader.int32();
                    break;
                case /* int32 max_results */ 2:
                    message.maxResults = reader.int32();
                    break;
                case /* bool include_inactive */ 3:
                    message.includeInactive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 start_position = 1; */
        if (message.startPosition !== 0)
            writer.tag(1, WireType.Varint).int32(message.startPosition);
        /* int32 max_results = 2; */
        if (message.maxResults !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxResults);
        /* bool include_inactive = 3; */
        if (message.includeInactive !== false)
            writer.tag(3, WireType.Varint).bool(message.includeInactive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBListQBOCustomersRequest
 */
export const QBListQBOCustomersRequest = new QBListQBOCustomersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBListQBOCustomersResponse$Type extends MessageType {
    constructor() {
        super("QBListQBOCustomersResponse", [
            { no: 1, name: "customers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBCustomer },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "start_position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "max_results", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customers = [];
        message.totalCount = 0;
        message.startPosition = 0;
        message.maxResults = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBCustomer customers */ 1:
                    message.customers.push(QBCustomer.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 start_position */ 3:
                    message.startPosition = reader.int32();
                    break;
                case /* int32 max_results */ 4:
                    message.maxResults = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBCustomer customers = 1; */
        for (let i = 0; i < message.customers.length; i++)
            QBCustomer.internalBinaryWrite(message.customers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        /* int32 start_position = 3; */
        if (message.startPosition !== 0)
            writer.tag(3, WireType.Varint).int32(message.startPosition);
        /* int32 max_results = 4; */
        if (message.maxResults !== 0)
            writer.tag(4, WireType.Varint).int32(message.maxResults);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBListQBOCustomersResponse
 */
export const QBListQBOCustomersResponse = new QBListQBOCustomersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBClass$Type extends MessageType {
    constructor() {
        super("QBClass", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "fully_qualified_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.fullyQualifiedName = "";
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string fully_qualified_name */ 3:
                    message.fullyQualifiedName = reader.string();
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string fully_qualified_name = 3; */
        if (message.fullyQualifiedName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.fullyQualifiedName);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBClass
 */
export const QBClass = new QBClass$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBClassMapping$Type extends MessageType {
    constructor() {
        super("QBClassMapping", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "realm_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "qb_class_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "qb_class_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.realmId = "";
        message.departmentId = 0;
        message.departmentName = "";
        message.qbClassId = "";
        message.qbClassName = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string realm_id */ 2:
                    message.realmId = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_name */ 4:
                    message.departmentName = reader.string();
                    break;
                case /* string qb_class_id */ 5:
                    message.qbClassId = reader.string();
                    break;
                case /* string qb_class_name */ 6:
                    message.qbClassName = reader.string();
                    break;
                case /* bool is_active */ 7:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string realm_id = 2; */
        if (message.realmId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.realmId);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* string department_name = 4; */
        if (message.departmentName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.departmentName);
        /* string qb_class_id = 5; */
        if (message.qbClassId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.qbClassId);
        /* string qb_class_name = 6; */
        if (message.qbClassName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.qbClassName);
        /* bool is_active = 7; */
        if (message.isActive !== false)
            writer.tag(7, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBClassMapping
 */
export const QBClassMapping = new QBClassMapping$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBClassMappingList$Type extends MessageType {
    constructor() {
        super("QBClassMappingList", [
            { no: 1, name: "mappings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBClassMapping }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.mappings = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBClassMapping mappings */ 1:
                    message.mappings.push(QBClassMapping.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBClassMapping mappings = 1; */
        for (let i = 0; i < message.mappings.length; i++)
            QBClassMapping.internalBinaryWrite(message.mappings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBClassMappingList
 */
export const QBClassMappingList = new QBClassMappingList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBCreateClassMappingRequest$Type extends MessageType {
    constructor() {
        super("QBCreateClassMappingRequest", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "qb_class_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "qb_class_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.qbClassId = "";
        message.qbClassName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* string qb_class_id */ 2:
                    message.qbClassId = reader.string();
                    break;
                case /* string qb_class_name */ 3:
                    message.qbClassName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* string qb_class_id = 2; */
        if (message.qbClassId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.qbClassId);
        /* string qb_class_name = 3; */
        if (message.qbClassName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.qbClassName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBCreateClassMappingRequest
 */
export const QBCreateClassMappingRequest = new QBCreateClassMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDeleteClassMappingRequest$Type extends MessageType {
    constructor() {
        super("QBDeleteClassMappingRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.departmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDeleteClassMappingRequest
 */
export const QBDeleteClassMappingRequest = new QBDeleteClassMappingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBDiscoverClassesResponse$Type extends MessageType {
    constructor() {
        super("QBDiscoverClassesResponse", [
            { no: 1, name: "classes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBClass }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.classes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBClass classes */ 1:
                    message.classes.push(QBClass.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBClass classes = 1; */
        for (let i = 0; i < message.classes.length; i++)
            QBClass.internalBinaryWrite(message.classes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBDiscoverClassesResponse
 */
export const QBDiscoverClassesResponse = new QBDiscoverClassesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBBackfillSalesTermsRequest$Type extends MessageType {
    constructor() {
        super("QBBackfillSalesTermsRequest", [
            { no: 1, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.dryRun = false;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool dry_run */ 1:
                    message.dryRun = reader.bool();
                    break;
                case /* int32 limit */ 2:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool dry_run = 1; */
        if (message.dryRun !== false)
            writer.tag(1, WireType.Varint).bool(message.dryRun);
        /* int32 limit = 2; */
        if (message.limit !== 0)
            writer.tag(2, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBBackfillSalesTermsRequest
 */
export const QBBackfillSalesTermsRequest = new QBBackfillSalesTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBBackfillSalesTermsRow$Type extends MessageType {
    constructor() {
        super("QBBackfillSalesTermsRow", [
            { no: 1, name: "kalos_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "qb_customer_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "qb_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_sub_customer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "billing_terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "qbo_term_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "qbo_term_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "action", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kalosUserId = 0;
        message.qbCustomerId = "";
        message.qbDisplayName = "";
        message.isSubCustomer = false;
        message.billingTerms = "";
        message.qboTermId = "";
        message.qboTermName = "";
        message.action = "";
        message.detail = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 kalos_user_id */ 1:
                    message.kalosUserId = reader.int32();
                    break;
                case /* string qb_customer_id */ 2:
                    message.qbCustomerId = reader.string();
                    break;
                case /* string qb_display_name */ 3:
                    message.qbDisplayName = reader.string();
                    break;
                case /* bool is_sub_customer */ 4:
                    message.isSubCustomer = reader.bool();
                    break;
                case /* string billing_terms */ 5:
                    message.billingTerms = reader.string();
                    break;
                case /* string qbo_term_id */ 6:
                    message.qboTermId = reader.string();
                    break;
                case /* string qbo_term_name */ 7:
                    message.qboTermName = reader.string();
                    break;
                case /* string action */ 8:
                    message.action = reader.string();
                    break;
                case /* string detail */ 9:
                    message.detail = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 kalos_user_id = 1; */
        if (message.kalosUserId !== 0)
            writer.tag(1, WireType.Varint).int32(message.kalosUserId);
        /* string qb_customer_id = 2; */
        if (message.qbCustomerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.qbCustomerId);
        /* string qb_display_name = 3; */
        if (message.qbDisplayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.qbDisplayName);
        /* bool is_sub_customer = 4; */
        if (message.isSubCustomer !== false)
            writer.tag(4, WireType.Varint).bool(message.isSubCustomer);
        /* string billing_terms = 5; */
        if (message.billingTerms !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.billingTerms);
        /* string qbo_term_id = 6; */
        if (message.qboTermId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.qboTermId);
        /* string qbo_term_name = 7; */
        if (message.qboTermName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.qboTermName);
        /* string action = 8; */
        if (message.action !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.action);
        /* string detail = 9; */
        if (message.detail !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.detail);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBBackfillSalesTermsRow
 */
export const QBBackfillSalesTermsRow = new QBBackfillSalesTermsRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBBackfillSalesTermsResponse$Type extends MessageType {
    constructor() {
        super("QBBackfillSalesTermsResponse", [
            { no: 1, name: "rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBBackfillSalesTermsRow },
            { no: 2, name: "updated", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "errors", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.rows = [];
        message.updated = 0;
        message.skipped = 0;
        message.errors = 0;
        message.dryRun = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBBackfillSalesTermsRow rows */ 1:
                    message.rows.push(QBBackfillSalesTermsRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 updated */ 2:
                    message.updated = reader.int32();
                    break;
                case /* int32 skipped */ 3:
                    message.skipped = reader.int32();
                    break;
                case /* int32 errors */ 4:
                    message.errors = reader.int32();
                    break;
                case /* bool dry_run */ 5:
                    message.dryRun = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBBackfillSalesTermsRow rows = 1; */
        for (let i = 0; i < message.rows.length; i++)
            QBBackfillSalesTermsRow.internalBinaryWrite(message.rows[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 updated = 2; */
        if (message.updated !== 0)
            writer.tag(2, WireType.Varint).int32(message.updated);
        /* int32 skipped = 3; */
        if (message.skipped !== 0)
            writer.tag(3, WireType.Varint).int32(message.skipped);
        /* int32 errors = 4; */
        if (message.errors !== 0)
            writer.tag(4, WireType.Varint).int32(message.errors);
        /* bool dry_run = 5; */
        if (message.dryRun !== false)
            writer.tag(5, WireType.Varint).bool(message.dryRun);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBBackfillSalesTermsResponse
 */
export const QBBackfillSalesTermsResponse = new QBBackfillSalesTermsResponse$Type();
/**
 * @generated ServiceType for protobuf service QuickBooksService
 */
export const QuickBooksService = new ServiceType("QuickBooksService", [
    { name: "GetAuthURL", options: {}, I: QBGetAuthURLRequest, O: QBGetAuthURLResponse },
    { name: "ExchangeCode", options: {}, I: QBExchangeCodeRequest, O: Bool },
    { name: "RefreshToken", options: {}, I: QBRefreshTokenRequest, O: Bool },
    { name: "GetHealthStatus", options: {}, I: Empty, O: QBHealthStatus },
    { name: "DiscoverQBOItems", options: {}, I: QBDiscoverItemsRequest, O: QBDiscoverItemsResponse },
    { name: "CreateItemMapping", options: {}, I: QBCreateItemMappingRequest, O: QBItemMapping },
    { name: "ListItemMappings", options: {}, I: Empty, O: QBItemMappingList },
    { name: "DeleteItemMapping", options: {}, I: QBDeleteItemMappingRequest, O: Bool },
    { name: "ListQBOCustomers", options: {}, I: QBListQBOCustomersRequest, O: QBListQBOCustomersResponse },
    { name: "CreateCustomerMapping", options: {}, I: QBCreateCustomerMappingRequest, O: QBCustomerMapping },
    { name: "ListCustomerMappings", options: {}, I: Empty, O: QBCustomerMappingList },
    { name: "DeleteCustomerMapping", options: {}, I: QBDeleteCustomerMappingRequest, O: Bool },
    { name: "DiscoverQBOClasses", options: {}, I: Empty, O: QBDiscoverClassesResponse },
    { name: "CreateClassMapping", options: {}, I: QBCreateClassMappingRequest, O: QBClassMapping },
    { name: "ListClassMappings", options: {}, I: Empty, O: QBClassMappingList },
    { name: "DeleteClassMapping", options: {}, I: QBDeleteClassMappingRequest, O: Bool },
    { name: "VoidInvoice", options: {}, I: QBVoidInvoiceRequest, O: QBVoidInvoiceResponse },
    { name: "BackfillCustomerSalesTerms", options: {}, I: QBBackfillSalesTermsRequest, O: QBBackfillSalesTermsResponse }
]);
